import { TooltipHost, getTheme, SpinButton, Position } from '@fluentui/react';
import { ReviewContext } from 'components/review/ReviewContextProvider';
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from 'Store/Admin';
import { ValidationMessage } from './rules/ValidationMessage';
import { settingsFieldStyles } from './SettingsStyles';

interface ConfigFieldProps {
  id: string;
  label: string;
  tooltip: string;
}

export const DEFAULT_MIN_ANIMATION_LOOP_SPEED = 2;
export const DEFAULT_MAX_ANIMATION_LOOP_SPEED = 10;

export const AnimationLoopSpeedField: React.FC<ConfigFieldProps> = props => {
  const { palette, fonts } = getTheme();
  const { state, dispatch } = useContext(AdminContext);
  const reviewContext = useContext(ReviewContext);
  const [value, setValue] = useState<string>('');
  const [showError, setShowError] = useState<boolean>(false);

  useEffect(() => {
    if (state.queueDataState) {
      const animationLoopSpeed = state.queueDataState.uxPreferences.subjectJson.animationLoopSpeed;
      if (animationLoopSpeed !== undefined) {
        setValue(String(animationLoopSpeed));
      }
    }
  }, [state.queueDataState]);

  const onComponentChange = (tempValue: string): void => {
    const numValue = Number(tempValue);
    const inRange = numValue >= DEFAULT_MIN_ANIMATION_LOOP_SPEED && numValue <= DEFAULT_MAX_ANIMATION_LOOP_SPEED;
    setShowError(!inRange);
    setValue(tempValue);

    if (!isNaN(numValue) && inRange) {
      dispatch({
        type: 'ANIMATION_LOOP_SPEED',
        payload: numValue
      });

      dispatch({
        type: 'IS_UPDATED',
        payload: true
      });

      reviewContext.dispatch({
        type: 'SET_ANIMATION_LOOP_SPEED',
        payload: numValue
      });
    }
  };

  return (
    <TooltipHost>
      <SpinButton
        id={props.id}
        label={props.label}
        labelPosition={Position.top}
        min={DEFAULT_MIN_ANIMATION_LOOP_SPEED}
        max={DEFAULT_MAX_ANIMATION_LOOP_SPEED}
        step={1}
        incrementButtonAriaLabel={`Increase value by 1`}
        decrementButtonAriaLabel={`Decrease value by 1`}
        value={value}
        onChange={(e, newValue) => onComponentChange(newValue || DEFAULT_MIN_ANIMATION_LOOP_SPEED.toString())}
        styles={settingsFieldStyles(palette, fonts, 60)}
      />
      {showError && <ValidationMessage message={`Invalid animation loop value`} fonts={fonts} />}
    </TooltipHost>
  );
};
